var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid portlet_wrapper",class:{
    [`portlet__${_vm.variant}`]: !!_vm.variant
  }},[_c('div',{staticClass:"portlet_header row"},[_c('div',{staticClass:"col-12"},[_vm._t("header")],2)]),_vm._v(" "),_c('div',{staticClass:"portlet_content row"},[_c('div',{staticClass:"col-12"},[_vm._t("default")],2)]),_vm._v(" "),_c('div',{staticClass:"portlet_footer row"},[_c('div',{staticClass:"col-12"},[_vm._t("footer")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }